import { ReportParametersUnion } from '@ndt/reports/shared/report-parameter-list/models/report-parameter-union.model';
import { TileViewModes } from 'generated/graphql-types';
import { DashboardTileLayoutConfiguration } from './dashboard-tile-layout-configuration.model';
import { Tile } from './tile.model';

export type DashboardTileUnionType = DashboardTile | PreviewDashboardTile | FullscreenDashboardTile;

export interface DashboardTile {
   dashboardTileId: number;
   totalMillisecondsProcessed: number;
   totalTimesProcessed: number;
   tile: Tile;
   viewMode: TileViewModes;
   dashboardTileLayoutConfiguration: DashboardTileLayoutConfiguration;
   dashboardTileParameters: ReportParametersUnion[];
}

export interface PreviewDashboardTile
   extends Omit<DashboardTile, 'dashboardTileId' | 'dashboardTileLayoutConfiguration'> {
   dashboardTileId: VerboseTileIds.previewTile;
   dashboardTileLayoutConfiguration: Omit<
      DashboardTileLayoutConfiguration,
      'dashboardTileLayoutConfigurationId' | 'minWidth' | 'minHeight' | 'maxWidth' | 'maxHeight' | 'x' | 'y'
   >;
}

export interface FullscreenDashboardTile extends Omit<DashboardTile, 'dashboardTileId'> {
   dashboardTileId: VerboseTileIds.fullscreenTile;
}

export enum VerboseTileIds {
      
   previewTile = -1,
   fullscreenTile = -2,
}
